import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'Service/api/api';

export const sendLetter = createAsyncThunk(`letter/send`, async (data: any) => {
  try {
    const response = await api.letter.sendLetter(data);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});
